module.exports = __webpack_public_path__ + "static/media/fountain.4977af84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/fountain.svg
// module id = 1518
// module chunks = 0